// import { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// export default function ScrollToTop() {
//   const { pathname } = useLocation(); // Corrected from 'pathName' to 'pathname'

//   useEffect(() => {
//     console.log('scrolling');
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   }, [pathname]);

//   return null;
// }

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Find the main content scroll container by its class
    const mainContentContainer = document.querySelector(
      '.flex-1.flex.flex-col.overflow-auto'
    );
    if (mainContentContainer) {
      // Scroll to the top of the container
      mainContentContainer.scrollTo({ top: 0 });
    }
  }, [pathname]);

  return null;
}
